module.exports = __webpack_public_path__ + "img/history.711549c7.svg";